export default "__VITE_ASSET__3NYz$goV__"